<template>
  <div>
    <el-form inline size="mini" label-width="100px" :model="conditions" :show-message="false" :rules="rules">
      <el-row :gutter="24">
        <el-col :lg="8" :md="12">
          <el-form-item label="产品ID">
            <el-input v-model="conditions.product_id" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="度数">
            <el-input :value="Number(conditions.degree)" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="产品描述" prop="short_text">
            <el-input v-model="conditions.short_text" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="盒装瓶数" prop="hzps">
            <el-input v-model.number="conditions.hzps" :disabled="role.ROLE !== 'WLYALL' && role.ROLE !== 'WLY004'" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="产品简介" prop="short">
            <el-input v-model="conditions.short" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="箱装盒数" prop="xzhs">
            <el-input v-model.number="conditions.xzhs" :disabled="role.ROLE !== 'WLYALL' && role.ROLE !== 'WLY004'" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="存货分类">
            <el-select
              v-model="conditions.chfl"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in selectDataOptions['A0019']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="是否有条形码">
            <el-checkbox v-model="conditions.isbar" true-label="X" false-label="" disabled />
            <!-- <el-select
                v-model="conditions.ISBAR"
                placeholder="请选择"
              >
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="基本单位">
            <el-input v-model="conditions.base_uom_text" value="盒" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="条形码">
            <el-input v-model="conditions.bcode" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="老编码">
            <el-input v-model="conditions.onumb" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="容量">
            <el-input v-model.number="conditions.capty" :disabled="role.ROLE !== 'WLYALL' && role.ROLE !== 'WLY004'" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="显示规格">
            <el-input v-model="conditions.norms" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="变更自产品">
            <el-input v-model="conditions.product_id" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="产品分类">
            <el-select
              v-model="conditions.pcate"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="item in selectDataOptions['A0017']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="归档标识">
            <el-checkbox v-model="conditions.zzfld000026" true-label="X" false-label="" @change="gdChange($event, 0)" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="归档日期">
            <el-input v-model="conditions.zzfld000026_date" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="归档备注">
            <el-input v-model="conditions.remark_gd" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="停用标识">
            <el-checkbox v-model="conditions.block" true-label="X" false-label="" @change="gdChange($event, 1)" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="停用日期">
            <el-input v-model="conditions.block_date" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="停用备注">
            <el-input v-model="conditions.remark_blk" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="预留项1">
            <el-select v-model="conditions.reserved1">
              <el-option value="E0006" label="预留项1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="预留项2">
            <el-select v-model="conditions.reserved2">
              <el-option value="E0006" label="预留项2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="预留项6">
            <el-input v-model="conditions.reserved6" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="预留项7">
            <el-input v-model="conditions.reserved7" />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="创建日期">
            <el-input v-model="conditions.datum" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="创建者">
            <el-input v-model="conditions.uname_text" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="更改日期">
            <el-input v-model="conditions.mdate" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="更改者">
            <el-input v-model="conditions.mname_text" disabled />
          </el-form-item>
        </el-col>
        <el-col :lg="8" :md="12">
          <el-form-item label="货主编码">
            <el-select
              v-model="conditions.shipper_code"
              placeholder="请选择"
            >
              <el-option
                v-for="item in selectDataOptions['A0068']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="停用/归档原因" class="line-16">
            <el-input v-model="conditions.remark_blk" type="textarea" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="table-container" style="padding: 0">
      <TableCommon
        title="营销单元"
        :custome-config="() => vxeShowCustom('xTableSaleCenter')"
      >
        <template #button>
          <table-button name="add" tip="增加" @click="showDialog = true" />
          <table-button name="delete" tip="删除" @click="removeSaleCenter" />
        </template>
        <vxe-grid
          ref="xTableSaleCenter"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: false }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="saleCenterGridOptions.columns"
          :data="saleCenterGridOptions.data"
        />
      </TableCommon>

      <TableCommon
        title="变更自产品"
        :custome-config="() => vxeShowCustom('xTable2')"
      >

        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: false }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridDataOptions.columns"
          :data="gridDataOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridDataOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="营销单元"
      width="70%"
    >
      <template v-if="showDialog">
        <SaleCenter ref="dialogComponent" />
      </template>
      <div slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmitSaleCenter">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
import SaleCenter from './SaleCenter.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    SaleCenter
  },
  props: {
    prod: {
      type: Object,
      default: () => null
    }
  },
  data() {
    const rules = {
      short: [{ required: true, message: '请填写必要字段！', trigger: 'blur' }],
      short_text: [{ required: true, message: '请填写必要字段！', trigger: 'blur' }],
      xzhs: [{ required: true, message: '请填写必要字段！', trigger: 'blur' }],
      hzps: [{ required: true, message: '请填写必要字段！', trigger: 'blur' }]
    }
    return {
      rules,
      showDialog: false,
      conditions: {
        product_id: '', // 产品id
        short: '', // 产品简介
        norms: '', // 显示规格
        onumb: '', // 老编码
        reserved1: '', // 预留1
        reserved2: '',
        reserved6: '',
        reserved7: '',
        xzhs: '', // 箱装盒数
        bcode: '', // 条形码
        capty: '', // 容量
        chfl: '', // 存货分类
        degree: '', // 度数
        hzps: '', // 盒装瓶数
        isbar: '', // 是否有条形码
        pcate: '', // 产品分类
        short_text: '', // 产品描述
        uname_text: '',
        mname_text: '',
        base_uom: '', // 基本单位
        base_uom_text: '',
        zzfld000026: '', // 归档标识
        zzfld000026_date: '',
        datum: '', // 创建日期
        uname: '', // 创建者
        mdate: '', // 更改日期
        mname: '', // 更改者
        block: '',
        block_date: '',
        remark_blk: '',
        shipper_code: ''
      },
      currentRow: {},
      selectDataOptions: {},
      saleCenterGridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          {
            field: 'zzfld00001h_dec',
            title: '营销单元'
          }
        ],
        data: []
      },
      gridDataOptions: {
        data: [],
        columns: [
          { type: 'seq', title: '序号', field: 'seq', width: 50 },
          { field: 'product_id_f', title: '初始产品' },
          { field: 'product_id_t', title: '变更产品' },
          { field: 'mdate', title: '变更日期' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.findWlyOrg()
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0017')
    this.getSelectDictDataOrigin('A0068')
    for (const key in this.conditions) {
      this.conditions[key] = this.prod[key] || ''
    }
    this.saleCenterGridOptions.data = this.prod.yxdy
    this.gridDataOptions.data = this.prod.history
  },
  methods: {
    gdChange(e, type) {
      if (e) {
        if (type === 0) {
          this.conditions.zzfld000026_date = new Date().toLocaleDateString().replaceAll('\/', '')
        } else {
          this.conditions.block_date = new Date().toLocaleDateString().replaceAll('\/', '')
        }
      } else {
        if (type === 0) {
          this.conditions.zzfld000026_date = ''
          this.conditions.remark_gd = ''
        } else {
          this.conditions.block_date = ''
          this.conditions.remark_blk = ''
        }
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          if (dictcode === 'A0019') {
            response.data.Rows.forEach(item => {
              item.name += '  |  ' + item.value
            })
          }
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 获取组织机构
    async findWlyOrg() {
      const { DATA } = await apiGetOrgOrBase()
      this.$set(this.selectDataOptions, 'saleCenterCodeOptions', DATA)
    },
    submitForm() {
      return {
        base: this.conditions,
        saleCenter: this.saleCenterGridOptions.data
      }
    },
    async handleSubmitSaleCenter() {
      const data = await this.$refs.dialogComponent.submitForm()
      if (data.length) {
        const res = data.filter(item => this.saleCenterGridOptions.data.findIndex(v => v.zzfld00001h === item.SOBID) < 0)
        res.forEach(this.insertSaleCenter)
      }
      this.showDialog = false
    },
    insertSaleCenter({ SOBID, MC_SHORT }) {
      const data = {
        mandt: '',
        product_guid: this.prod.product_guid,
        product_id: this.prod.product_id,
        zzfld00001h: SOBID,
        zzfld00001h_dec: MC_SHORT
      }
      this.saleCenterGridOptions.data.unshift(data)
    },
    removeSaleCenter() {
      const checkedList = this.$refs.xTableSaleCenter.getCheckboxRecords()

      checkedList.forEach(item => {
        const index = this.saleCenterGridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.saleCenterGridOptions.data.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product-manage/components/BaseInfo.vue